// extracted by mini-css-extract-plugin
export var text = "_4g-0";